import { render } from "./OrderBackFooter.vue?vue&type=template&id=227930c1"
import script from "./OrderBackFooter.vue?vue&type=script&lang=js"
export * from "./OrderBackFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__